
          import "Tooltip.styles_ps7v5n.linaria.css";
          import { styled } from "@linaria/react";
const Styles = /*#__PURE__*/styled("span")({
  name: "Styles",
  class: "sighif"
});
export { Styles };
          